<template>
  <div id="app">
    <div
      class="my-4 px-2 d-flex justify-content-center align-items-center"
      style="max-width: 1000px; margin: auto"
    >
      <div>
        <img
          src="@/assets/logo.png"
          class="navbar-logo"
        >
      </div>
      <div>
        <button
          v-if="showLogin"
          class="btn px-4 btn-success"
          @click="goToPlatform"
        >
          Zaloguj
        </button>
      </div>
    </div>

    <RouterView
      :pending="pending && badges.length === 0"
    />
  </div>
</template>

<script>
import axios from '@home/api';
import { mapState } from 'vuex';

export default {
  data: () => ({
    showLogin: false,
    pending: false,
  }),
  computed: {
    ...mapState({
      badges: (state) => state.badges,
    }),
  },
  methods: {
    goToPlatform() {
      window.location.href = 'login.html';
    },
  },
  created() {
    this.pending = true;
    axios.get('/forms')
      .then(({ data }) => {
        this.$store.commit('setBadges', data.badges);
        this.$store.commit('setCategories', data.categories);
      })
      .finally(() => {
        this.pending = false;
      });
  },
};
</script>

<style lang="scss">
.navbar-logo {
  max-height: 40px
}
</style>
